import React from "react";
import "./TablePaginationPlaceholder.scss";

export default function TablePaginationPlaceholder() {
  return <div className="table-pagination-placeholder" aria-hidden />;
}
